module.exports = __webpack_public_path__ + "static/media/microsoft.6e7eb394.jpg";